// Heat Alert API endpoints using RTK Query

import { baseApi } from './baseApi'
import { API_ENDPOINTS } from '@/constants'
import type {
  HeatAlertsResponse,
  CheckHeatResponse,
} from '@/types'

export const heatAlertApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all active heat alerts for current user
    getHeatAlerts: builder.query<HeatAlertsResponse, void>({
      query: () => API_ENDPOINTS.HEAT_ALERTS.BASE,
      transformResponse: (response: HeatAlertsResponse) => response,
      providesTags: (result) =>
        result && result.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'HeatAlert' as const, id })),
              { type: 'HeatAlert', id: 'LIST' },
            ]
          : [{ type: 'HeatAlert', id: 'LIST' }],
    }),

    // Get heat alerts for specific cow
    getHeatAlertsByCow: builder.query<HeatAlertsResponse, string>({
      query: (cowId) => API_ENDPOINTS.HEAT_ALERTS.BY_COW(cowId),
      transformResponse: (response: HeatAlertsResponse) => response,
      providesTags: (result, _error, cowId) =>
        result && result.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'HeatAlert' as const, id })),
              { type: 'HeatAlert', id: cowId },
            ]
          : [{ type: 'HeatAlert', id: cowId }],
    }),

    // Manually check cow for heat (trigger immediate check)
    checkCowForHeat: builder.mutation<CheckHeatResponse, string>({
      query: (cowId) => ({
        url: API_ENDPOINTS.HEAT_ALERTS.CHECK(cowId),
        method: 'POST',
      }),
      transformResponse: (response: CheckHeatResponse) => response,
      invalidatesTags: (_result, _error, cowId) => [
        { type: 'HeatAlert', id: 'LIST' },
        { type: 'HeatAlert', id: cowId },
        { type: 'Notification', id: 'LIST' },
      ],
    }),
  }),
})

export const {
  useGetHeatAlertsQuery,
  useGetHeatAlertsByCowQuery,
  useCheckCowForHeatMutation,
} = heatAlertApi
